var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { trpc } from '@web/lib/trpc';
import { getUrl } from '@web/router/getUrl';
import { appsUrl } from '@web/router/urls';
import { getDriveLinkByType, getIconByType } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { appsActiveTabs } from '@web/utility/tabs';
import { DocumentInsightsEnum, DriveEventActionEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
var sections = [
    DocumentInsightsEnum.topEdited,
    DocumentInsightsEnum.topViewed,
    DocumentInsightsEnum.mostCommented,
    DocumentInsightsEnum.mostChangesSuggested,
    DocumentInsightsEnum.unresolvedComments,
    DocumentInsightsEnum.suggestionsPending,
    DocumentInsightsEnum.approvalRequested,
    DocumentInsightsEnum.approvalPending,
    DocumentInsightsEnum.topDownloaded,
    DocumentInsightsEnum.topCopied
];
var getActionTypeBySectionName = function (sectionName) {
    switch (sectionName) {
        case DocumentInsightsEnum.mostCommented:
            return DriveEventActionEnum.DOCUMENT_CREATE_COMMENT;
        case DocumentInsightsEnum.mostChangesSuggested:
            return DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION;
        case DocumentInsightsEnum.topViewed:
            return DriveEventActionEnum.DOCUMENT_VIEW;
        case DocumentInsightsEnum.topEdited:
            return DriveEventActionEnum.DOCUMENT_EDIT;
        case DocumentInsightsEnum.topDownloaded:
            return DriveEventActionEnum.DOCUMENT_DOWNLOAD;
        case DocumentInsightsEnum.topCopied:
            return DriveEventActionEnum.DOCUMENT_COPY;
        case DocumentInsightsEnum.unresolvedComments:
            return DriveEventActionEnum.DOCUMENT_CREATE_COMMENT;
        case DocumentInsightsEnum.suggestionsPending:
            return DriveEventActionEnum.DOCUMENT_CREATE_SUGGESTION;
        case DocumentInsightsEnum.approvalRequested:
            return DriveEventActionEnum.DOCUMENT_APPROVAL_REQUESTED;
        default:
            return null;
    }
};
var InsightsTable = function () {
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _a = useFilters(), userId = _a.user, dateFrom = _a.dateFrom, dateTo = _a.dateTo, orgUnitId = _a.orgUnit, activityLabelId = _a.activityLabel;
    var itemsListLength = 5;
    var documentInsightsData = trpc.documentInsights.useQuery({
        userId: userId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        orgUnitId: orgUnitId,
        activityLabelId: activityLabelId
    }).data;
    if (!documentInsightsData)
        return null;
    return (_jsxs("div", { children: [_jsx("h3", __assign({ className: "text-xl font-semibold text-gray-900 ml-4 mb-4" }, { children: t('app.apps.drive.insights.title') })), _jsx("div", __assign({ className: "grid md:grid-cols-2 bg-white shadow-sm ring-1 ring-black ring-opacity-5 rounded-lg" }, { children: sections.map(function (section, index) {
                    var _a, _b, _c;
                    return (_jsxs("div", __assign({ className: "border-b border-gray-200\n            ".concat(index === 0 ? 'rounded-tl-lg rounded-bl-lg' : '', " \n            ").concat(index === 1 ? 'rounded-tr-lg rounded-br-lg' : '') }, { children: [_jsx("h3", __assign({ className: "bg-gray-50 text-gray-500 text-xs font-semibold mb-2 p-4 uppercase rounded-tl-lg rounded-t-lg" }, { children: t("app.apps.drive.insights.".concat(section)) })), _jsxs("ul", __assign({ className: "flex flex-col p-4 h-40 overflow-y-auto" }, { children: [((_a = documentInsightsData[section]) === null || _a === void 0 ? void 0 : _a.length) === 0 ? (_jsx("li", __assign({ className: "flex justify-center items-center h-full text-gray-500 text-sm font-normal" }, { children: t('noData') }))) : ((_b = documentInsightsData[section]) === null || _b === void 0 ? void 0 : _b.slice(0, 5).map(function (_a, subIndex) {
                                        var title = _a.title, type = _a.type, actionCount = _a.actionCount, slugId = _a.slugId;
                                        return (_jsxs("li", __assign({ className: "flex justify-between text-gray-500 text-sm font-normal items-center" }, { children: [_jsxs(Link, __assign({ to: getDriveLinkByType(type, slugId), target: "_blank", className: "flex justify-between items-center gap-1" }, { children: [getIconByType(type), _jsx("span", { children: title })] })), _jsx("span", __assign({ className: "mr-5" }, { children: actionCount }))] }), "".concat(index, "-").concat(subIndex)));
                                    })), ((_c = documentInsightsData[section]) === null || _c === void 0 ? void 0 : _c.length) > itemsListLength && (_jsx("li", __assign({ className: "mr-5 text-gray-500 text-xs cursor-pointer self-end", onClick: function () {
                                            var driveSearchAction = getActionTypeBySectionName(section);
                                            navigateTo({
                                                pathname: getUrl(appsUrl, appsActiveTabs.driveAdvancedSearch),
                                                newFilters: __assign({}, (driveSearchAction && {
                                                    driveSearchAction: driveSearchAction,
                                                    hasInitialSearch: true
                                                }))
                                            });
                                        } }, { children: t('app.apps.drive.insights.more') })))] }))] }), section));
                }) }))] }));
};
export default InsightsTable;
